import { useCallback, useContext } from 'react'

import { clearSignedInApp } from '@scoir/redirects'
import { useSelector } from 'react-redux'

import api from 'common/api'
import { removeBearerToken } from 'common/bearer'
import userPilotHelper from 'common/user-pilot-helper'
import window from 'common/window'
import { AuthShieldContext } from 'components/AuthShield'
import { selectUserId } from 'store/user'

interface IuseLogoutProps {
  realtimeLogout: () => void
  clearCollegeCompare: () => void
}

export const useLogout = ({ realtimeLogout, clearCollegeCompare }: IuseLogoutProps) => {
  const userId = useSelector(selectUserId)
  const { setIsAuthed, setIsLoggingOut } = useContext(AuthShieldContext)
  return useCallback(() => {
    api.get('/api/logout').then(() => {
      clearSignedInApp('student')
      clearCollegeCompare()
      removeBearerToken()
      userPilotHelper.logout()
      if (window.dataLayer) {
        console.log('logging out tracked userId:', userId) // eslint-disable-line no-console
        window.gtag({ event: 'logout', user_id: userId, session_id: undefined })
      }
      setIsLoggingOut(true)
      setIsAuthed(false)
      realtimeLogout()
    })
  }, [clearCollegeCompare, setIsAuthed, setIsLoggingOut, realtimeLogout, userId])
}
